import { put, takeLatest } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import { Types, Creators as CategoryCreators } from '../../reducers/category';

function* setFormatViewProducts({ data }) {
  try {
    yield put(
      CategoryCreators.setFormatViewProductsSuccess({
        formatViewProducts: data,
      })
    );
  } catch (error) {
    yield put(CategoryCreators.setFormatViewProductsError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SET_FORMAT_VIEW_PRODUCTS_REQUEST, setFormatViewProducts);
}
